import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import SalesPartnerPayouts from '@/components/v2/affiliate/SalesPartnerPayouts';
import AffiliateMixin from '@/helpers/mixins/AffiliateMixin';
import SalesPartnerPayoutExportManager from '@/components/v2/affiliate/SalesPartnerPayoutExportManager.vue';
import SalesPartnerPayoutsExport from '@/components/v2/affiliate/SalesPartnerPayoutsExport';
import moment from 'moment';
let SalesPartnerPayout = class SalesPartnerPayout extends Mixins(AffiliateMixin) {
    get headers() {
        return [
            {
                text: 'BILLING MONTH',
                value: 'billingMonth',
                align: 'left',
                sortable: false,
            },
            {
                text: 'BILLING NUMBER',
                value: 'billingNumber',
                align: 'left',
                sortable: false,
            },
            {
                text: 'BILLING PERIOD',
                value: 'billignPeriod',
                align: 'left',
                sortable: false,
            },
            {
                text: 'TIER TYPE',
                value: 'tierType',
                align: 'left',
                sortable: false,
            },
            {
                text: 'TOTAL BILLING AMOUNT',
                value: 'billingAmount',
                align: 'left',
                sortable: false,
            },
            {
                text: 'DUE DATE',
                value: 'dueDate',
                align: 'left',
                sortable: false,
            },
            {
                text: 'PAYMENT DATE AND TIME',
                value: 'paymentDate',
                align: 'left',
                sortable: false,
            },
            {
                text: 'COMMISSION AMOUNT (10%)',
                value: 'commission',
                align: 'left',
                sortable: false,
            },
            {
                text: 'STATUS',
                value: 'status',
                align: 'left',
                sortable: false,
            },
        ];
    }
    /**
     * Formatted Billing Start Month
     * @author Angelo David <adavid@gorated.ph>
     * @since Version {0.65.1}
     *
     * @return {string}
     */
    getBillingMonth(billingStartDate) {
        const format = 'MMMM';
        return moment(billingStartDate).format(format);
    }
};
SalesPartnerPayout = __decorate([
    Component({
        components: {
            SalesPartnerPayouts,
            SalesPartnerPayoutsExport,
            SalesPartnerPayoutExportManager,
        },
    })
], SalesPartnerPayout);
export default SalesPartnerPayout;
